angular
    .module('app')
    .directive('phoneValidation', function () {
        return {
            require: 'ngModel',
            link: function (scope, element, attrs, ctrl) {

                function customPhoneValidation(value) {

                    ctrl.$setValidity('phoneValid', isPhoneValid(value));

                    return value;
                }

                ctrl.$parsers.push(customPhoneValidation);
            }
        };
    })
